const num = (v) => (v === null || v === undefined ? null : Number(v));

export const dollarsFromCents = (c) => {
  const n = num(c);
  return Number.isFinite(n) ? n / 100 : null;
};

export const getPriceDollars = (obj) => {
  if (!obj) return null;

  if (obj.price_cents != null) return dollarsFromCents(obj.price_cents);
  if (obj.cents != null) return dollarsFromCents(obj.cents);

  const raw =
    obj.latest_price ??
    obj.price ??
    obj.current_price ??
    obj.latestPrice ??
    null;

  if (raw == null || raw === "") return null;

  if (typeof raw === "number" && Number.isFinite(raw)) {
    return Number.isInteger(raw) ? raw / 100 : raw;
  }

  const s = String(raw).trim();
  const cleaned = s.replace(/[^0-9.]/g, "");
  const n = Number(cleaned);
  if (!Number.isFinite(n)) return null;

  if (cleaned.includes(".")) return n;

  return n / 100;
};

export const formatPrice = (obj) => {
  const dollars = getPriceDollars(obj);
  if (dollars == null) return "";
  return dollars.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
